import script from "./TabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=61caadf0&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61caadf0"]])

export default __exports__